import { Platform } from 'react-native';

const STORAGE_KEY_SNP_CSID = 'snowplow_custom_id_snp_csid';
const STORAGE_KEY_CORRELATION_ID = 'snowplow_custom_id_correlation_id';
export const CUSTOM_ID_SCHEMA = 'iglu:com.dgp/custom_id/jsonschema/1-0-1';

// Self-generated web session id, distinguishable from platform-issued DCB ids
// (sp-phkma-...) by its prefix, so server-side stitching can tell them apart.
function generateWebSnpCsid(): string {
  let hex: string;
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    hex = crypto.randomUUID().replace(/-/g, '');
  } else {
    hex = Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
  }
  return `sp-web-${hex}`;
}

let memorySnpCsid: string | null = null;
let memoryCorrelationId: string | null = null;

function getSessionStorage(): Storage | null {
  if (Platform.OS === 'web' && typeof window !== 'undefined' && window.sessionStorage) {
    return window.sessionStorage;
  }
  return null;
}

export function setCustomIdContext(snpCsid: string, correlationId?: string | null): void {
  memorySnpCsid = snpCsid;
  memoryCorrelationId = correlationId ?? null;

  const storage = getSessionStorage();
  if (storage) {
    storage.setItem(STORAGE_KEY_SNP_CSID, snpCsid);
    if (correlationId) {
      storage.setItem(STORAGE_KEY_CORRELATION_ID, correlationId);
    } else {
      storage.removeItem(STORAGE_KEY_CORRELATION_ID);
    }
  }
}

export function getCustomIdContext(): { schema: string; data: { snp_csid: string; correlation_id?: string | null } } | null {
  let snpCsid = memorySnpCsid;
  let correlationId = memoryCorrelationId;

  if (!snpCsid) {
    const storage = getSessionStorage();
    if (storage) {
      snpCsid = storage.getItem(STORAGE_KEY_SNP_CSID);
      correlationId = storage.getItem(STORAGE_KEY_CORRELATION_ID);
      if (snpCsid) {
        memorySnpCsid = snpCsid;
        memoryCorrelationId = correlationId;
      }
    }
  }

  // No DCB-issued id in this browser session: self-generate one so every web
  // event carries a custom_id context. A DCB callback id set later via
  // setCustomIdContext() overwrites it for the rest of the session.
  if (!snpCsid && Platform.OS === 'web' && typeof window !== 'undefined') {
    snpCsid = generateWebSnpCsid();
    correlationId = null;
    setCustomIdContext(snpCsid);
    console.log(`[snowplow][web] Generated web snp_csid: ${snpCsid}`);
  }

  if (!snpCsid) return null;

  const data: { snp_csid: string; correlation_id?: string | null } = { snp_csid: snpCsid };
  if (correlationId) {
    data.correlation_id = correlationId;
  }

  return { schema: CUSTOM_ID_SCHEMA, data };
}

export function clearCustomIdContext(): void {
  memorySnpCsid = null;
  memoryCorrelationId = null;

  const storage = getSessionStorage();
  if (storage) {
    storage.removeItem(STORAGE_KEY_SNP_CSID);
    storage.removeItem(STORAGE_KEY_CORRELATION_ID);
  }
}
